import { MspModel } from '../MspModel';

export class TaskComment extends MspModel {
    public description: string;
    public forecastId?: string;
}
